// locale config
import tw from "./tw";
import cn from "./cn";
export default {
  "zh-hk": tw,
  "zh-cn": cn,
};
